export default "__VITE_ASSET__040da3e8__"